import script from "./CustomResourceApplyXXL.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyXXL.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyXXL.vue?vue&type=style&index=0&id=9c5b3b46&lang=less&scope=true"

const __exports__ = script;

export default __exports__